import React from 'react';
import TemplatePage, { TemplateSection } from './TemplatePage';

// F4 (McKayla Loom "Current Site Feedback Part 1" t=1:25, ClickUp 86bah7dqn).
// Verbatim: "Resources. This is important. We definitely need a resource
// library that they can click. We need tools. We need use cases. We should
// have a blog. Success stories we need. We need pretty much white papers.
// Yeah, let's do a white paper."
//
// The six sections below are exactly the six she named, in the order she named
// them. Do not add a seventh or drop one without her — the list IS the request.
// She stated the contents are hers to supply: "that's something I'm going to
// need to get you is like what goes on the page."
const SECTIONS: Array<{ heading: string; body: string }> = [
  { heading: 'Resource library', body: 'A filterable library of everything below. Contents pending.' },
  { heading: 'Tools', body: 'Placeholder for advisor-facing tools. Contents pending.' },
  { heading: 'Use cases', body: 'Placeholder for worked examples of the product in practice. Contents pending.' },
  { heading: 'Blog', body: 'Placeholder for articles. Contents pending.' },
  { heading: 'Success stories', body: 'Placeholder for client stories. Contents pending.' },
  { heading: 'White papers', body: 'Placeholder for long-form research pieces. Contents pending.' },
];

export default function Resources() {
  return (
    <TemplatePage
      title="Resources"
      intro="A placeholder hub for the six resource sections McKayla asked for. Each one is an empty template until the content lands."
    >
      {SECTIONS.map((s) => (
        <TemplateSection key={s.heading} heading={s.heading} body={s.body} />
      ))}
    </TemplatePage>
  );
}
